export default __webpack_public_path__ + "static/media/web.057abf8c.svg";